import React, {Fragment, useCallback, useMemo, useState, useEffect} from "react";
import ViewIcon from "../../assets/image/icon_eye.svg"
import Split from "../../assets/image/split.svg"
import useFetch from "@common/hooks/fetch/useFetch";
import {Moments} from "@common/utils/date/moments";
import Prev from "../../assets/image/icon_prev.svg";
import Delete from "../../assets/image/icon_trash.svg";
import {Link, useHistory, useParams} from "react-router-dom";
import {
  getMyAdWatchViewList,
  removeAllMyAdWatchViewList,
  removeMyAdWatchViewList
} from "@common/services/restapi/mypage";
import AdCategory from "@common/enums/AdCategory.enums";
import Page from "@common/enums/Page.enums";
import Sort from '../../../common/enums/Sort.enums'
import {useAsyncFn} from "react-use";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {convertPath} from "@common/utils/path/linkPath";
import InterSectionObserver from "@common/components/intersection/InterSectionObserver";
import {useAuth} from "@common/contexts/auth/AuthProvider";

const AD_CATEGORY_MENU = [AdCategory.tv, AdCategory.print, AdCategory.radio, AdCategory.outdoor, AdCategory.cinema, AdCategory.inet,
  AdCategory.internet, AdCategory.inet, AdCategory.mobile, AdCategory.newtype, AdCategory.foreign];

const SORT_LIST = [Sort.wdate, Sort.acount];

function MyAd() {

  const auth = useAuth();
  const { adicUser } = auth;
  const history = useHistory();

  const [page, setPage] = useState(Page.page.defaultPage);
  const [myAdCategoryList, setMyAdCategoryList] = useState([]);

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[]);


  const searchQuery = useMemo(() => {
    return {
      pageNumber: page,
      pageSize: Page.size.defaultSize
    }
  },[page]);


  const {data: adWatchList, refetch, loading: dataLoading} = useFetch(() => getMyAdWatchViewList(searchQuery), [searchQuery], {});

  // 내가 본 광고 삭제
  const [removeAdWatchView, handleRemoveAdWatchView] = useAsyncFn(async(reqBody) => {
    if (!removeAdWatchView.loading) {
      await removeMyAdWatchViewList(reqBody);
      await refetch();
    }
  });

  // 내가 본 광고 전체 삭제
  const [removeAllMyAdWatchView, handleRemoveAllMyAdWatchView] = useAsyncFn(async(reqBody) => {
    if (!removeAllMyAdWatchView.loading) {
      await removeAllMyAdWatchViewList(reqBody);

      await refetch();
    }
  });

  const handleObserver = useCallback(() => {
    setPage(page + 1);
  }, [page]);

  useEffect(() => {
    if (adWatchList && adWatchList.histories && adWatchList.histories.length > 0) {
      setMyAdCategoryList(myAdCategoryList.concat(adWatchList.histories));
    }
  }, [adWatchList]);

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">내가 본 광고</h3>
      </div>

      <section className="common-body--list">
        <div className="row-box">
          {
            adWatchList.totalCount &&
            <div className="video-count">광고 <span>{adWatchList.totalCount}</span>개</div>
          }
          <button className="empty-btn" onClick={() => handleRemoveAllMyAdWatchView({userId: 'test'})}>전체 비우기</button>
        </div>
        <div className="ad-list">
          {
            myAdCategoryList &&
            myAdCategoryList.map((eachData) => {
              return (
                <div className="ad-box small-horizontal" key={`ad-${eachData.ad.ukey}`}>
                  <a href={convertPath(`/ad/${eachData.adCategory}/${eachData.ad.ukey}`)}>
                    <div className="thumbnail-card-wrapper">
                      <LazyLoadImage className="thumbnail-card small-video" src={`${eachData.ad.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                    </div>
                  </a>
                  <div className="ad-info has-delete">
                    <a href={convertPath(`/ad/${eachData.adCategory}/${eachData.ad.ukey}`)} className="left-box">
                      <h4 className="title">{eachData.ad.title}</h4>
                      <h5 className="company">{eachData.ad.brand}</h5>
                      <div className="row-box">
                        {
                          eachData.ad.rcount !== 0 &&
                          <>
                            <div className="view-count">
                              <img src={ViewIcon} alt=""/>
                              <span>{eachData.ad.rcount}</span>
                            </div>
                            <img src={Split} alt=""/>
                          </>
                        }
                        <div className="created-date">{Moments.Format(eachData.ad.wdate, 'yyyy.MM.DD')}</div>
                      </div>
                    </a>
                    <i className="delete-icon" onClick={() => handleRemoveAdWatchView({id: eachData.id})}><img src={Delete}/></i>
                  </div>
                </div>
              )
            })
          }
        </div>
        {
          adWatchList && adWatchList.totalCount > myAdCategoryList.length && <InterSectionObserver dataLoading={dataLoading} onHandleObserver={handleObserver}/>
        }
      </section>
    </>
  )
}

export default MyAd;
